import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { IPageDataV3, IPageDataV4 } from '@df/catalog/cms/cms-model.interface';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { ImageModule } from '@df/module-image/image.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { DfUiModule } from '@df/ui/df-ui.module';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { BehaviorSubject } from 'rxjs';
import { LocalPage } from '../../catalog/page/local/local-page';
import { ButtonStyleComponent } from '../../common/buttons/button-style/button-style.component';
import { NTextBox, TextBoxComponent } from '../../common/text-box/text-box.component';
import { NInformationPageType } from '../information/page/cms-information-page.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfImageWrapperComponent } from '../../../../../../git_modules/@tomandco/dragonfly-module-image/src/df-image-wrapper.component';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';

export namespace NCmsInfoPagesListing {
    export interface IComponentData extends NICmsContentComponent.IData {
        infoPages: number[];
    }
}

@ICmsComponent<CmsInfoPagesListingComponent>({
    id: 'info-pages-listing',
    name: 'Info Pages Listing',
    tags: ['info pages', 'info pages listing'],
    fields: [
        ...NTextBox.getFields(false, true),

        <NICmsContentField.IRelationField>{
            key: 'infoPages',
            type: NICmsContentField.EFieldType.relation,
            title: 'Select Pages',
            required: true,
            default: [-100, -101, -102, -103, -104],
            options: {
                type: 'page',
                title: 'Info pages',
                filter: model => {
                    return model.pageType === NInformationPageType.typeId;
                },
                multiple: true
            }
        }
    ]
})
@Component({
    standalone: true,
    imports: [
        TextBoxComponent,
        ICmsClientModule,
        ToggleModule,
        ButtonStyleComponent,
        HrefComponent,
        GridModule,
        DfUiModule,
        TranslationModule,
        DfModuleImageModule
    ],
    selector: 'cms-info-pages-listing',
    templateUrl: './cms-info-pages-listing.html',
    styleUrl: './cms-info-pages-listing.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsInfoPagesListingComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsInfoPagesListing.IComponentData;

    _icmsContent$?: BehaviorSubject<NCmsInfoPagesListing.IComponentData>;

    models: LocalPage<IPageDataV3>[] = [];

    private loadStatus = new Status();

    private app = inject(App);

    override ngOnInit(): void {
        super.ngOnInit();
        if (this._icmsContent$) {
            this.subscriptions.add(
                this._icmsContent$.subscribe(() => {
                    this.setModels();
                })
            );
        }
    }

    private setModels(): void {
        const ids = this.component?.infoPages || [];
        if (this.loadStatus.promise?.cancel) {
            this.loadStatus.promise.cancel();
        }
        this.detectChanges();
        if (ids.length) {
            this.app.request.send(
                this.loadStatus,
                () => {
                    return this.app.resources.page.loadAllIds(ids, 3, { safe: true });
                },
                () => {
                    this.models = this.app.resources.page.getAllExisting(ids) as LocalPage<IPageDataV3>[];
                    this.detectChanges();
                }
            );
        }
    }
}
